import { render, staticRenderFns } from "./ImagemBem.vue?vue&type=template&id=8776d3aa&"
import script from "./ImagemBem.vue?vue&type=script&lang=js&"
export * from "./ImagemBem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports